var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mainContainer" }, [
    _c("div", { staticClass: "title" }, [
      _c("div", { staticClass: "titleValue" }, [_vm._v(_vm._s(_vm.count))]),
      _vm._v(" "),
      _c("div", { staticClass: "titleName" }, [_vm._v(" " + _vm._s(_vm.title))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }